export default function ContentNotice({ unavailable }) {
  return unavailable ? <p className="content-notice" role="status">The latest updates could not be loaded. Showing a saved copy; refresh to try again.</p> : null;
}
